














import { defineComponent, PropType } from '@vue/composition-api';
import IdentityList from '../common/list.vue';
import { IdentityItem } from '../types';
const name = 'ttam-identity-tiktok-list';

export default defineComponent({
  name,
  components: { IdentityList },
  props: {
    dataSource: {
      type: Array as PropType<IdentityItem[]>,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onChange = (val: IdentityItem) => {
      emit('input', val.id);
      emit('identity-change', val);
    };

    const onPopoverCTA = (val: IdentityItem) => {
      emit('identity-popover-click', val);
    };
    return {
      name,
      onChange,
      onPopoverCTA,
    };
  },
});
